// @flow

import React, { useState, useMemo } from "react";

import { useCombobox, autocomplete } from "@szhsin/react-autocomplete";

type Course = {
  "@id": string,
  title: string,
  class_code?: string,
  course_type?: string,
  external_website?: string,
};

type Props = {
  courses: Course[],
  course_type: string,
  onUpdate: (value: string) => void,
  SearchableText: string,
  translations: { [key: string]: string },
  vocabulary: any,
};

const LiveSearchInput = ({
  courses,
  course_type,
  onUpdate,
  SearchableText,
  translations,
  vocabulary,
  name = "SearchableText",
}: Props) => {
  const [inputValue, setInputValue] = useState(SearchableText || "");
  const [selected, setSelected] = useState();

  // 🔍 Filtra i corsi in base al testo digitato
  const filteredCourses = useMemo(() => {
    if (!inputValue) return courses;
    const lowerValue = inputValue.toLowerCase();
    return courses.filter((c) => c.title.toLowerCase().includes(lowerValue));
  }, [courses, inputValue]);

  const handleSelect = (key) => {
    const selected = courses.find((c) => c["@id"] === key);
    if (selected) {
      setInputValue(selected.title);
      onUpdate(selected.title);
    }
  };

  const placeholder =
    translations?.search_placeholder_text || "Search courses...";

  const {
    getLabelProps,
    getInputProps,
    getClearProps,
    getToggleProps,
    getListProps,
    getItemProps,
    isItemSelected,
    open,
    focusIndex,
    isInputEmpty,
  } = useCombobox({
    items: courses,
    value: inputValue,
    getItemValue: (item) => item.title,
    isEqual: (item1, item2) => item1?.["@id"] === item2?.["@id"],
    onChange: (value) => {
      setInputValue(value);
      onUpdate(value);
    },
    selected,
    onSelectChange: setSelected,
    feature: autocomplete({
      // The `select` option controls autocomplete in free or select mode
      select: false, // or false
      // Other options: rovingText, deselectOnClear, deselectOnChange, closeOnSelect
    }),
  });

  return (
    <div className="autocomplete-wrapper search-course-input">
      <div>
        <input
          name={name}
          /*placeholder={placeholder}*/ aria-label={placeholder}
          {...getInputProps()}
        />
        {/* {!isInputEmpty && <button {...getClearProps()}>X</button>}
        <button {...getToggleProps()}>{open ? "↑" : "↓"}</button> */}
      </div>

      <ul
        {...getListProps()}
        style={{
          display: open ? "block" : "none",
          position: "absolute",
          listStyle: "none",
          color: "#000",
          background: "#fff",
          overflow: "auto",
          maxHeight: 300,
          margin: 0,
          padding: 0,
        }}
      >
        {filteredCourses.length ? (
          filteredCourses.map((item, index) => (
            <li
              style={{
                background: focusIndex === index ? "#ddd" : "none",
                textDecoration: isItemSelected(item) ? "underline" : "none",
              }}
              key={item}
              {...getItemProps({ item, index })}
              onClick={(e) => e.stopPropagation()}
              className="search-res"
            >
              <a href={item.external_website || item["@id"]}>
                {item.title}
                <div>
                  {item.class_code}
                  {item.class_code && item.course_type ? " - " : ""}
                  {vocabulary && vocabulary.CourseTypes
                    ? vocabulary.CourseTypes[item.course_type]
                    : item.course_type}
                </div>
              </a>
            </li>
          ))
        ) : (
          <li>No results</li>
        )}
      </ul>
    </div>
  );
};

export default LiveSearchInput;
